/**
 * nurseryArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const nurseryArtPack: ToilePack = {
    slug: 'nursery-art',
    category: 'nursery',
    name: 'Nursery art',
    tagline: tagline('prints', 'motifs', 'styles'),
    chips: chips('motifs', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'safari', label: 'Safari babies', subject: 'a baby elephant, giraffe, lion cub and zebra together'},
        {key: 'moon', label: 'Moon & stars', subject: 'a smiling crescent moon, stars and drifting clouds'},
        {key: 'balloons', label: 'Hot-air balloons', subject: 'three balloons rising over low hills, tiny birds'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'pale transparent washes, blurred edges', palette: 'muted blush and sage, bare paper', framing: 'centered, clear margin, no frame'},
        {key: 'scandi', label: 'Flat scandi', style: 'simple cut-out shapes, no outlines', palette: 'ochre, dusty blue, clay, off-white', framing: 'centered, wide negative space'},
        {key: 'storybook', label: 'Vintage storybook', style: 'fine ink linework, subtle paper grain', palette: 'warm faded 1950s print colors', framing: 'centered, clear margin, no frame'},
    ],
    directions: ['woodland animals instead', 'in warm terracotta tones', 'with a name added'],
}
